import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/scss/app.scss'
import '@/assets/css/tailwind.css'
import VueTheMask from 'vue-the-mask'
import Theme from '@/theme.js'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VueTailwind from 'vue-tailwind'

Vue.component('pagseguro',
  () => import(/* webpackChunkName: "pagseguro" */'@/views/layout/pagseguro')
)
Vue.component('yapay',
  () => import(/* webpackChunkName: "yapay" */ '@/views/layout/yapay')
)
Vue.component('mercadopago',
  () => import(/* webpackChunkName: "mercadopago" */'@/views/layout/mercadopago')
)

Vue.config.productionTip = false

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)

/** Currency */

Vue.filter('toCurrency', function (value) {
  if (!value) {
    value = 0
  }
  return parseFloat(value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
})
Vue.use(VueTailwind, Theme)
Vue.use(VueTheMask)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
